import { useEffect, useState } from 'react'

import { DisconnectOutlined, LinkOutlined } from '@ant-design/icons'
import { Button, Input, Popover } from 'antd'
import { createStyles } from 'antd-style'

import { pick } from '@eastcoal/common/utils/object'

import { MenuButton } from '../../../MenuButton'
import { useImageCardStore } from '../../Store/hooks/useStore'

const useStyles = createStyles(({ token }) => ({
  popoverOverlay: {
    [`& .ant-popover-inner-content`]: {
      width: 320,
      overflow: 'hidden'
    }
  },
  buttonGroup: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBlockStart: token.marginSM
  }
}))

export const LinkDropdown = () => {
  const { link, setLink, getPopupContainer } = useImageCardStore(state =>
    pick(state, ['link', 'setLink', 'getPopupContainer'])
  )

  const [value, setValue] = useState<string>()

  useEffect(() => {
    setValue(link)
  }, [link])

  const { styles } = useStyles()

  const content = (
    <>
      <Input
        placeholder='请输入网址'
        value={value}
        onBlur={() => {
          setLink(value)
        }}
        onChange={e => {
          setValue(e.target.value)
        }}
      />
      <div className={styles.buttonGroup}>
        <Button
          disabled={!value}
          icon={<DisconnectOutlined />}
          type='text'
          onClick={() => {
            setLink('')
          }}
        >
          取消链接
        </Button>
      </div>
    </>
  )

  return (
    <Popover
      arrow={false}
      classNames={{ root: styles.popoverOverlay }}
      content={content}
      getPopupContainer={getPopupContainer}
      placement='bottomLeft'
      trigger='click'
    >
      <MenuButton tooltip='链接'>
        <LinkOutlined />
      </MenuButton>
    </Popover>
  )
}
